
export default {
  // Header
  "logo_alt": "onexip Logo",
  
  // Calculator
  "calculator_title": "Project Cost Estimator",
  "calculator_subtitle": "Answer a few questions about your project requirements to get a detailed cost estimate.",
  
  // Platforms Step
  "platform_title": "Which platforms do you want to target?",
  "platform_subtitle": "Select one or more platforms for your application",
  "platform_ios": "iOS",
  "platform_android": "Android",
  "platform_web": "Web",
  "platform_cross": "Cross-Platform",
  
  // App Type Step
  "apptype_title": "What type of app do you need?",
  "apptype_subtitle": "Select the complexity level for your application",
  "apptype_mvp": "MVP",
  "apptype_mvp_desc": "Basic app with essential features to validate your idea",
  "apptype_full": "Full-Featured",
  "apptype_full_desc": "Complete app with comprehensive features and refined UX",
  "apptype_enterprise": "Enterprise",
  "apptype_enterprise_desc": "Robust solution with advanced features for large-scale use",
  
  // Features Step
  "features_title": "Which features do you need?",
  "features_subtitle": "Select the features for your application",
  "feature_auth": "User Authentication",
  "feature_auth_desc": "Login, registration, and user management",
  "feature_logo": "Logo Design",
  "feature_logo_desc": "Professional logo design for your app",
  "feature_ui": "Custom UI/UX Design",
  "feature_ui_desc": "Unique, branded interface design",
  "feature_chat": "Real-time Chat",
  "feature_chat_desc": "Instant messaging between users",
  "feature_payments": "Payments/In-app Purchases",
  "feature_payments_desc": "Process payments and handle transactions",
  "feature_gps": "GPS/Maps Integration",
  "feature_gps_desc": "Location-based features and mapping",
  "feature_backend": "Backend with Database",
  "feature_backend_desc": "Server and database infrastructure",
  "feature_admin": "Admin Panel",
  "feature_admin_desc": "Dashboard for managing your app",
  "feature_api": "API Integration",
  "feature_api_desc": "Connect with external services",
  "feature_push": "Push Notifications",
  "feature_push_desc": "Real-time alerts to users",
  "feature_offline": "Offline Mode",
  "feature_offline_desc": "App functionality without internet",
  "feature_cloud": "Cloud Sync",
  "feature_cloud_desc": "Data synchronization across devices",
  
  // User Volume Step
  "volume_title": "How many users do you expect?",
  "volume_subtitle": "Select the expected user volume for your application",
  "volume_selected": "Selected volume:",
  "volume_cost": "Additional cost:",
  "volume_small": "Small (Up to 100 users)",
  "volume_medium": "Medium (Up to 1,000 users)",
  "volume_large": "Large (Up to 100,000 users)",
  "volume_enterprise": "Enterprise (100,000+ users)",
  
  // Maintenance Step
  "maintenance_title": "Do you need maintenance & support?",
  "maintenance_subtitle": "Select a maintenance plan or skip this step",
  "maintenance_6": "6 Month Maintenance",
  "maintenance_6_desc": "Bug fixes and critical updates for 6 months",
  "maintenance_12": "12 Month Maintenance",
  "maintenance_12_desc": "Bug fixes, updates, and minor enhancements for 1 year",
  "maintenance_24": "24 Month Maintenance",
  "maintenance_24_desc": "Full support, updates, and feature enhancements for 2 years",
  "maintenance_none": "No maintenance plan needed",
  
  // Navigation
  "btn_next": "Next",
  "btn_previous": "Previous",
  "btn_results": "See Results",
  
  // Footer
  "footer_copyright": "© {{year}} onexip. All rights reserved.",
  
  // Language
  "language": "Language",
  "language_en": "English",
  "language_de": "Deutsch"
};
